<template>
  <div>
    <div class="right-title">
      <span>顾问详情</span>
      <el-button plain class="go-back" @click="goBack">返回</el-button>
    </div>
    <div class="content-box">
      <div class="gw-info-box">
        <el-form ref="form" :model="form" :rules="rules" label-width="120px">
          <el-form-item label="帐号：" prop="account">
            <el-input v-model="form.account" placeholder="请输入帐号"></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="name">
            <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="帐号类型：">
            <el-select v-model="form.type" @change="typeChange(form.type)" placeholder="请选择" style="width: 100%;">
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="帐号从属：" v-show="Type !== 2" prop="superior">
            <el-select v-model="form.superior" filterable @change="cityChange(form.superior)" placeholder="请选择"
                       style="width: 100%;" :disabled="disabelSuperior">
              <el-option
                v-for="item in superiorOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管辖区域：" v-show="Type !== 2" prop="city">
            <el-select v-model="form.city" multiple filterable placeholder="请选择" style="width: 100%;" >
              <el-option
                v-for="item in cityOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="管辖区域：" v-show="Type === 2" prop="city">
            <div
              style="width: 100%;line-height: 40px;padding: 0 10px;color: #999;border: 1px solid #DCDFE6;border-radius: 6px;cursor: pointer;"
              v-if="chioseCityArr.length === 0&&!quanguo"
              @click="showAllCity"
            >请选择</div>
            <div v-else-if="quanguo"
                 style="display: flex;align-items: center;flex-wrap: wrap;border: 1px solid #DCDFE6;border-radius: 6px;cursor: pointer;"
                 @click="Visible = true">
              <span style="display: block;padding: 5px 10px;margin: 0 5px 5px 0;">全国</span>
            </div>
            <div v-else
                 style="display: flex;align-items: center;flex-wrap: wrap;border: 1px solid #DCDFE6;border-radius: 6px;cursor: pointer;"
                 @click="Visible = true">
              <span v-for="item in chioseCityArr" :key="item.id"
                    style="display: block;padding: 5px 10px;margin: 0 5px 5px 0;">{{item.categoryname}}</span>
            </div>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" class="submit" @click="onSubmit()">完成</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <footerBox class="footer"/>
    <el-dialog append-to-body :close-on-click-modal="false" :visible.sync="Visible">
      <div class="dialogBox">
        <div class="title">管辖区域</div>
        <div class="city-box">
          <div>
            <el-checkbox v-model="quanguo">全国</el-checkbox>
            <div style="margin: 15px 0;"></div>
          </div>
          <div v-show="!quanguo" v-for="(item,index) in cityAllList" :key="item.id">
            <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.state"
                         @change="handleCheckAllChange(index)">{{item.categoryname}}
            </el-checkbox>

            <div style="padding-left: 30px;">
              <el-checkbox v-for="(city,j) in item.er" v-model="city.state" @change="handleCheckedCitiesChange(index,j)"
                           :label="city.categoryname" :key="city.id">{{city.categoryname}}
              </el-checkbox>
            </div>
            <div style="margin: 15px 0;"></div>
          </div>
        </div>
        <el-button class="btn" type="primary" @click="submitCity()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "gwAdd",
    data() {
      return {
        Type: 0,
        typeOptions: [],
        superiorOptions: [],
        cityOptions: [],
        disabelSuperior: false,    // 帐号从属是否可以选择
        cityAllList: [],               // 全部城市
        Visible: false,            //  城市选项模块显示隐藏
        chioseCityArr: [],         //  选择的城市
        quanguo: false,             //  是否选择全国
        id:'',                      //  顾问id
        form: {
          id: '',           //  帐号id
          account: '',     //  帐号
          name: '',        //  姓名
          type: '',         //  帐号类型
          superior: '',     //  帐号从属
          city: [],         //  管辖区域

        },
        rules: {
          account: [
            {required: true, message: '请输入帐号', trigger: 'blur'},
            {min: 6, message: '长度需六位字符以上', trigger: 'blur'}
          ],
          name: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
          ],
          type: [
            {required: true, message: '请选择帐号类型', trigger: 'change'}
          ],
          superior: [
            {required: true, message: '请选择帐号从属', trigger: 'change'}
          ],
          city: [
            {required: 'array', message: '请至少选择一个管辖区域', trigger: 'change'}
          ]
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if (this.user.admin_type === 1) {
        this.typeOptions = [{
          value: 3,
          label: '顾问'
        }, {
          value: 4,
          label: '客服'
        }, {
          value: 2,
          label: '总顾问'
        }]
      } else if (this.user.admin_type === 2) {
        this.typeOptions = [{
          value: 3,
          label: '顾问'
        }, {
          value: 4,
          label: '客服'
        }]
      }
      this.$emit('setType', 0);
      this.congshuList();
      this.id = this.$route.params.id
      this.detail();
      if (this.user.admin_type === 2) {
        this.form.superior = this.user.id
        this.cityAll()
        this.disabelSuperior = true
      }
    },
    methods: {
      //个人详情
      detail() {
        this.$api.apiContent.cityAll()
          .then(res => {
            let cityList = res.data
            cityList.map(item => {
              item.state = false
              item.isIndeterminate = false
              item.checkedCities = []
              item.er.map(items=>{
                items.state = false
              })
            })
            this.cityAllList = cityList;
          }).catch(res => {
          console.log(res)
        })
        this.$api.apiContent.gwDetail({
          user_id: this.id,
          admin_id: this.user.id
        }).then(res => {
          this.form.id = res.data.id
          this.form.account = res.data.username
          this.form.name = res.data.name
          this.form.type = res.data.admin_type
          this.form.superior = res.data.parent_id
          if(res.data.typeid === 1){
            this.quanguo = true
          }
          if (this.form.type === 2) {
            this.Type = 2
            this.rules.city = []
            console.log(res)
            this.chioseCityArr = res.data.city_id
            this.cityAllList.map(item => {
              item.er.map(items=>{
                this.chioseCityArr.map(itemss =>{
                  console.log(itemss)
                  if(items.id === itemss.city_id) items.state = true
                })
              })
            })
            this.cityAllList.map(item => {
              item.er.map(items => {
                if (items.state) {
                  item.checkedCities.push(items)
                }
              })
              if (item.checkedCities.length === item.er.length && item.checkedCities.length !==0) {
                item.state = true
              }
            })
            console.log( this.cityAllList)
          }else{
            let _list = res.data.city_id
            var CityArr = []
            for (let i = 0; i < _list.length; i++) {
              CityArr.push(Number(_list[i].city_id))
            }
            this.form.city = CityArr
            console.log(this.form.city)
            this.cityChange(this.id)
          }

        }).catch(res => {
          this.$message.error(res.info);
        })
      },
      goBack() {     //  返回上一页
        this.$tools.goBack()
      },
      onSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              look: true,
              text: 'Loading',
              spinner: 'el-icon-loading',
              background: 'rgba(0,0,0,0.7)'
            });
            let data = ''
            if (this.Type !== 2) {
              data = {
                user_name: this.form.account,
                name: this.form.name,
                admin_type: this.form.type,
                parent_id: this.form.superior,
                city_id: this.form.city.join(','),
                typeid: 3,
                admin_id: this.user.id,
                user_id: this.id
              }
            } else {
              if (this.quanguo) {
                data = {
                  user_name: this.form.account,
                  name: this.form.name,
                  admin_type: this.form.type,
                  parent_id: this.form.superior,
                  city_id: '',
                  typeid: 1,
                  admin_id: this.user.id,
                  user_id: this.id
                }
              } else {
                if (this.chioseCityArr.length === 0) {
                  loading.close();
                  this.$message.error('请选择管辖区域');
                  return
                }
                let _arr = []
                this.chioseCityArr.map(item => {
                  _arr.push(item.id)
                })
                data = {
                  user_name: this.form.account,
                  name: this.form.name,
                  admin_type: this.form.type,
                  parent_id: this.form.superior,
                  city_id: _arr.join(','),
                  typeid: 3,
                  admin_id: this.user.id,
                  user_id: this.id
                }
              }
            }

            this.$api.apiContent.gwEdit(data)
              .then(res => {
                loading.close();
                this.$message.success(res.info)
                this.$refs.form.resetFields()
                this.form.name = ''
                this.$router.push('/home/gwAdmin/gwList')
              }).catch(res => {
              loading.close();
              this.$message.error(res.info);
            })
          }
        })
      },
      //  显示全部城市
      showAllCity() {
        this.Visible = true
      },
      //  选择全省
      handleCheckAllChange(index) {
        let _state = this.cityAllList[index].state
        this.cityAllList[index].er.map(item => {
          console.log(item)
          item.state = _state
        })
      },
      //  选择市
      handleCheckedCitiesChange(index, j) {
        let _id = this.cityAllList[index].er[j].id
        if (this.cityAllList[index].checkedCities.indexOf(_id) === -1) {
          this.cityAllList[index].checkedCities.push(_id)
        } else {
          this.cityAllList[index].checkedCities.splice(this.cityAllList[index].checkedCities.findIndex(item => item === _id), 1)
        }
        if (this.cityAllList[index].checkedCities.length === this.cityAllList[index].er.length) {
          this.cityAllList[index].state = true
        } else {
          this.cityAllList[index].state = false
        }
      },
      //  确定选择
      submitCity() {
        this.chioseCityArr = []
        if (this.quanguo) {
          let _obj = {
            id: 0,
            categoryname: '全国'
          }
          this.chioseCityArr.push(_obj)
        } else {
          this.cityAllList.map(item => {
            item.er.map(items => {
              if (items.state) {
                console.log(items)
                this.chioseCityArr.push(items)
              }
            })
          })
        }

        this.Visible = false
      },
      //显示隐藏账号从属
      typeChange(value) {
        this.Type = value
        if (value === 2) {
          this.cityAll()
          this.rules.superior = []
          this.form.superior = ''
          this.rules.city = []
          this.form.city = ''
        } else {
          this.rules.superior = [{required: true, message: '请选择帐号从属', trigger: 'change'}]
          this.cityChange(this.user.id)
          this.rules.city = [
            {required: 'array', message: '请至少选择一个管辖区域', trigger: 'change'}
          ]
        }
      },
      //  全部城市
      cityAll() {
        this.$api.apiContent.cityAll()
          .then(res => {
            let cityList = res.data
            cityList.map(item => {
              item.state = false
              item.isIndeterminate = false
              item.checkedCities = []
              item.er.map(items => {
                items.state = false
              })
            })
            this.cityAllList = cityList;
            console.log(this.cityAllList)
          }).catch(res => {
          console.log(res)
        })
      },
      //城市显示
      cityChange(value) {
        var data = {
          parentid: value,
        }
        this.$api.apiContent.gxcsList(data)
          .then(res => {
            let cityList = res.data
            cityList.map(item => {
              item.label = item.categoryname
              item.value = item.city_id
            })
            this.cityOptions = cityList;
          }).catch(res => {
          console.log(res)
        })
      },
      //账号从属数据
      congshuList() {
        this.$api.apiContent.gwcsList({
          admin_id: this.user.id
        })
          .then(res => {
            let list = res.data
            list.map(item => {
              item.label = item.name
              item.value = item.id
            })
            this.superiorOptions = list;
          }).catch(res => {
          console.log(res)
        })
      }

    },
    watch: {},
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .gw-info-box {
    width: 500px;
    padding: 50px 0;
    margin: 0 auto;

  }

  .submit {
    width: 100%;
  }

  .dialogBox {
    .title {
      font-size: 30px;
      text-align: center;
      margin-bottom: 20px;
    }
  }
</style>